import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { Box, ListItemText, useMediaQuery } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import {
  FontAwesomeIconStyled,
  LeafListItemButtonMobileStyled,
  LeafListItemTextStyled,
} from '»components/Menus';
import { isMenuOpened } from '»components/Menus/menus.selectors';
import { TrlFeedbackModal } from '»components/molecules/TrlFeedbackModal';
import { useAlertModalStatus } from '»utils/customHooks';

import {
  ListItemIconStyled,
  RootListItemButtonStyled,
} from '../../Menus/Menu.styles';
import { logoutSlice } from './_logout.slice';

export const Logout = () => {
  const dispatch = useDispatch();
  const matches = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const menuOpened = useSelector(isMenuOpened);
  const alertModalStatus = useAlertModalStatus(false);

  const logoutRequest = () => {
    dispatch(logoutSlice.actions.logoutRequest({ showAlert: false }));
  };

  if (matches) {
    return (
      <>
        <LeafListItemButtonMobileStyled
          sx={{ justifyContent: 'center' }}
          onClick={(event) => {
            alertModalStatus.onChangeStatus({ event, isOpen: true });
          }}
          id="btnMenuLogout"
        >
          <LeafListItemTextStyled
            primary={<FormattedMessage id="TRLT_UI-LOGOUT" />}
            isLogoutOption
          />
        </LeafListItemButtonMobileStyled>
        <TrlFeedbackModal
          title={{ content: 'TRLT_UI-LOGOUT' }}
          descr={{ content: 'TRLT_UI-CONFIRM_LOGOUT' }}
          type="warning"
          open={alertModalStatus.isOpen}
          onClose={() => {
            alertModalStatus.onChangeStatus({ isOpen: false });
          }}
          mainActionBtnNameExp="TRLT_UI-LOGOUT"
          mainActionMethod={logoutRequest}
        />
      </>
    );
  }

  return (
    <Box>
      <RootListItemButtonStyled
        onClick={(event) => {
          alertModalStatus.onChangeStatus({ event, isOpen: true });
        }}
        isOpen={menuOpened}
        id="btnMenuLogout"
      >
        <ListItemIconStyled>
          <FontAwesomeIconStyled icon={faRightFromBracket} />
        </ListItemIconStyled>
        <ListItemText primary={<FormattedMessage id="TRLT_UI-LEAVE" />} />
      </RootListItemButtonStyled>
      <TrlFeedbackModal
        title={{ content: 'TRLT_UI-LOGOUT' }}
        descr={{ content: 'TRLT_UI-CONFIRM_LOGOUT' }}
        open={alertModalStatus.isOpen}
        onClose={() => {
          alertModalStatus.onChangeStatus({ isOpen: false });
        }}
        mainActionBtnNameExp="TRLT_UI-LOGOUT"
        mainActionMethod={logoutRequest}
      />
    </Box>
  );
};
